import { render, staticRenderFns } from "./ChartPPR.vue?vue&type=template&id=122a61f6&scoped=true&"
import script from "./ChartPPR.vue?vue&type=script&lang=js&"
export * from "./ChartPPR.vue?vue&type=script&lang=js&"
import style0 from "./ChartPPR.vue?vue&type=style&index=0&id=122a61f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122a61f6",
  null
  
)

export default component.exports
import {QCard,QCardSection,QDialog,QLayout,QHeader,QToolbar,QToolbarTitle,QBtn,QPageContainer,QPage,QTable,QTh,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QDialog,QLayout,QHeader,QToolbar,QToolbarTitle,QBtn,QPageContainer,QPage,QTable,QTh}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
